module.exports = __webpack_public_path__ + "img/neuro_cardio_musculo_skeletal.f34a874a.jpg";